<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            {{cameraName}}
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>
      <zj-layout-container :style="{overflow:hidden}" class="content video-monitor">
        <!-- <zj-camera-preview
          :style="{ height:'100%',width:'100%',overflow: hidden}"
          :cameraId="cameraId"
          :cameraName="cameraName"
          :autoplay="autoplay"
        /> -->
        <videoItem
                :cameraId="cameraId"
                :cameraName="cameraName"
                :streamUrl="streamUrl"
                autoplay="true"
              />
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import videoItem from "./hlsPlayer.vue"
// import VideoMonitorControl from "./Component-VideoMonitorControl";
import dataServerApi from "../../../../../../../request/dataServerApi";
export default {
  name: "ZJEmergencyComponentVideoGrow",
  componentName: "ZJEmergencyComponentVideoGrow",
  props: {
    cameraId: String,
    cameraName: String,
    streamUrl: String,
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    videoItem: videoItem
  },
  data(){
    // streamUrl:""
  },
  watch:{
    cameraId:function(val){
      console.log("val")
      console.log(val)
      if(val&&!this.streamUrl){
        this.getStreamUrlByCode(val)
      }
    }
  },
  methods:{
    onBack: function () {
      this.$emit("handlerclose");
    },
    getStreamUrlByCode(code) {
      let params= {"indexCode":code}
      // let params= {"indexCode":"865ac4e15d0947d7bec6349ddf380f2d"}
      dataServerApi.getstreamurl(params).then(res=>{
        // console.log("streamUrl_res")s
        // console.log(res)
        if(res.code==0){
          let streamUrl = res.data.data.url;
          this.streamUrl =streamUrl;
          console.log("streamUrl")
          console.log(streamUrl)
          // console.log(this.cameras)
        }
      })
    }
  }
};
</script>